/******/ (() => { // webpackBootstrap
/**
 * Cart Bundle Remove — Custom Element
 *
 * Removes an entire Build-a-Box bundle (all of a product's line items) in one
 * action. Build-a-Box adds each flavour as its own line item; the cart drawer
 * and cart page collapse those into a single non-editable "bundle card", and
 * this element powers that card's single Remove control.
 *
 * Usage:
 *   <cart-bundle-remove data-line-keys="key1,key2,key3">
 *     <button data-bundle-remove-button>Remove</button>
 *   </cart-bundle-remove>
 *
 * It posts every line key (quantity 0) to /cart/update.js. Inside the cart
 * drawer it re-renders the drawer via the Section Rendering API; on the cart
 * page it reloads so the server-rendered table refreshes.
 */
class CartBundleRemove extends HTMLElement {
  constructor() {
    super();
    this.onClick = this.onClick.bind(this);
  }

  connectedCallback() {
    if (window.wetheme && window.wetheme.webcomponentRegistry) {
      window.wetheme.webcomponentRegistry.register({ key: 'component-cart-bundle-remove' });
    }
    this.trigger = this.querySelector('[data-bundle-remove-button]') || this;
    this.trigger.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    if (this.trigger) this.trigger.removeEventListener('click', this.onClick);
  }

  get lineKeys() {
    return (this.getAttribute('data-line-keys') || '')
      .split(',')
      .map((key) => key.trim())
      .filter(Boolean);
  }

  // Inside the cart drawer we re-render in place; on the cart page we reload.
  get isInDrawer() {
    return !!this.closest('cart-drawer');
  }

  async onClick(event) {
    event.preventDefault();
    if (this.classList.contains('is-removing')) return;

    const keys = this.lineKeys;
    if (!keys.length) return;

    this.classList.add('is-removing');

    const updates = {};
    keys.forEach((key) => { updates[key] = 0; });

    const body = { updates };
    if (this.isInDrawer) body.sections = 'cart-drawer';

    try {
      const response = await fetch(window.routes.cart_update_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const cart = await response.json();

      if (this.isInDrawer) {
        if (cart && cart.sections && cart.sections['cart-drawer']) {
          window.eventBus.emit('update:cart:drawer', { sections: { 'cart-drawer': cart.sections['cart-drawer'] } });
        } else {
          window.eventBus.emit('render:cart:drawer');
        }
        if (window.wetheme && window.wetheme.updateCartCount) {
          window.wetheme.updateCartCount(cart);
        }
      } else {
        window.location.reload();
      }
    } catch (error) {
      console.error('Cart bundle remove error:', error);
      this.classList.remove('is-removing');
    }
  }
}

if (!customElements.get('cart-bundle-remove')) {
  customElements.define('cart-bundle-remove', CartBundleRemove);
}
/******/ })()
;
